
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Taxiservicenearme() {



    const cardData =
    {
        keyword: 'Taxi Service Near Me',
        heading: 'Meghana Cab : Taxi Service Near Me',
        headingDescription: 'Meghana Cab offers dependable Taxi Service Near Me, catering to all your local and outstation travel needs with just a click. Whether you are heading to work, catching a flight, or planning a day out, our nearby taxis are available 24/7 for quick and comfortable rides. With GPS-enabled cabs, professional drivers, and a fleet of clean, well-maintained vehicles, we ensure prompt service and a smooth journey. Book your nearby taxi with Meghana Cab for safe, affordable, and on-time travel—right when you need it.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is a grand fortification in the heart of Pune. Once the political center of the Maratha Empire, it features massive gateways, ancient ruins, and a famous evening light and sound show that narrates its rich history. A must-visit for heritage lovers. 🏰"
  },
  {
    "title": "Aga Khan Palace",
    "description": "This majestic palace was built in 1892 and played a pivotal role during India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and others. With lush gardens and a museum preserving Gandhi’s belongings, it’s a serene site filled with historic significance. 🕊️"
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a cliff about 30 km from Pune, Sinhagad Fort is famed for the 1670 battle led by Tanaji Malusare. Trekking up offers stunning views, historical ruins, and rustic snacks like pithla bhakri served by local villagers. Ideal for history buffs and adventure seekers. 🗻"
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses an eclectic collection of over 20,000 artifacts collected by Dr. Dinkar Kelkar. From sculptures and musical instruments to weapons and everyday items from different eras, it’s a treasure trove showcasing India’s rich cultural heritage. 🏺"
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. With its monolithic architecture, tranquil ambiance, and sacred sanctum, it's a hidden gem in Pune’s city center. 🕉️"
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Located just outside Pune, this dam is a favorite for locals seeking scenic drives, lakeside relaxation, and street food. The cool breeze, reflections on the water, and nearby picnic spots make it ideal for a peaceful escape. 🌊"
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped garden in Pune features flowing streams, bridges, lush greenery, and koi ponds. Perfect for quiet strolls, family time, and photography. 🌸"
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this tranquil center is dedicated to meditation, mindfulness, and holistic wellness. Visitors from around the world come here for dynamic meditation, spa therapies, and peaceful surroundings. 🌿"
  },
  {
    "title": "Fergusson College Road",
    "description": "A buzzing street in Pune known for its youthful vibe, cafes, street food, bookstores, and fashion boutiques. It’s a favorite hangout spot among students and a perfect place to experience Pune’s vibrant urban culture. ☕"
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in 1630 by Shivaji Maharaj’s father Shahaji Bhosale, this historic red palace is where young Shivaji spent part of his childhood. The present-day structure contains paintings and exhibits that celebrate his life and legacy. 🔴"
  }
],

"services": [
    {
        "name": "Local Taxi Near Me Pune",
        "description": "Find reliable local taxi services near you in Pune with Meghana Cab. Whether it’s a quick ride or a planned trip, our cabs are just around the corner and ready to go."
    },
    {
        "name": "Book Nearby Taxi Service Pune",
        "description": "Book a nearby taxi in Pune quickly with Meghana Cab. Our responsive service ensures a cab reaches your location in minutes for a comfortable journey."
    },
    {
        "name": "Affordable Taxi Near Me Pune",
        "description": "Looking for low-cost taxi services near you in Pune? Meghana Cab offers budget-friendly fares for local and short-distance travel without compromising on quality."
    },
    {
        "name": "24/7 Nearby Cabs Pune",
        "description": "Need a cab anytime, day or night? Meghana Cab offers 24/7 taxi availability near you in Pune with prompt service and professional drivers."
    },
    {
        "name": "Local Cab Operator Near Me Pune",
        "description": "Meghana Cab is your trusted local cab operator in Pune. Book with a nearby service provider that knows the city routes and ensures timely pickups."
    },
    {
        "name": "Taxi for Short Distance Near Me Pune",
        "description": "Need a ride for a short distance in Pune? Meghana Cab provides quick and affordable local taxis for small commutes and errands near your area."
    },
    {
        "name": "Outstation Cab Near Me Pune",
        "description": "Planning an outstation trip? Find outstation cabs near your location in Pune with Meghana Cab’s fast and reliable services across Maharashtra and beyond."
    },
    {
        "name": "Fast Taxi Nearby in Pune",
        "description": "Get a fast response when you need a cab urgently. Meghana Cab offers the quickest nearby taxi dispatch in Pune for instant travel needs."
    },
    {
        "name": "Cab Nearby for Daily Commute Pune",
        "description": "Book cabs near you in Pune for daily office or college commute. Meghana Cab ensures reliable, punctual rides at affordable rates."
    },
    {
        "name": "Find a Cab Near Me in Pune",
        "description": "Use Meghana Cab’s platform to instantly find a cab near you in Pune. Real-time availability, quick bookings, and safe rides are guaranteed."
    },
    {
        "name": "Airport Taxi Near Me Pune",
        "description": "Looking for an airport taxi near you in Pune? Meghana Cab provides fast and convenient pickup and drop service to and from Pune Airport."
    },
    {
        "name": "Local Sightseeing Cab Near Me Pune",
        "description": "Explore Pune with a local sightseeing cab near you. Meghana Cab offers city tours and local attractions in comfortable cabs with experienced drivers."
    },
    {
        "name": "Nearby Driver Hire Pune",
        "description": "Need a driver near you in Pune? Meghana Cab offers driver hire services for personal vehicles or chauffeured cab options for all needs."
    },
    {
        "name": "Emergency Taxi Near Me Pune",
        "description": "In a hurry? Book an emergency taxi near you in Pune with Meghana Cab’s rapid response services. Available 24/7 for urgent travel."
    },
    {
        "name": "Taxi on Call Near Me in Pune",
        "description": "Get a taxi on call near your location in Pune. Meghana Cab offers prompt service via phone or app for immediate bookings."
    }
],

"tableData": [
    ["Local Taxi Near Me Pune", "Book Nearby Taxi Service Pune"],
    ["Affordable Taxi Near Me Pune", "24/7 Nearby Cabs Pune"],
    ["Local Cab Operator Near Me Pune", "Taxi for Short Distance Near Me Pune"],
    ["Outstation Cab Near Me Pune", "Fast Taxi Nearby in Pune"],
    ["Cab Nearby for Daily Commute Pune", "Find a Cab Near Me in Pune"],
    ["Airport Taxi Near Me Pune", "Local Sightseeing Cab Near Me Pune"],
    ["Nearby Driver Hire Pune", "Emergency Taxi Near Me Pune"],
    ["Taxi on Call Near Me in Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Taxi Service Near Me in Pune",
        "WhyChoosedescription": "Looking for a taxi nearby? Meghana Cab provides prompt and dependable taxi service near you in Pune, perfect for quick rides, local commutes, or emergency travel needs."
    },
    {
        "WhyChooseheading": "Fast Response and On-Time Pickups",
        "WhyChoosedescription": "Our taxi network ensures that a cab is always close to your location. With fast response times and punctual pickups, we get you where you need to go, without the wait."
    },
    {
        "WhyChooseheading": "Wide Coverage Across Pune",
        "WhyChoosedescription": "No matter where you are in Pune—be it Koregaon Park, Hinjewadi, Kothrud, or Viman Nagar—our extensive network ensures there's always a Meghana Cab near you."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Fares",
        "WhyChoosedescription": "Enjoy affordable taxi fares with no hidden costs. Meghana Cab offers competitive and transparent pricing whether you’re traveling nearby or across the city."
    },
    {
        "WhyChooseheading": "Clean, Safe, and Sanitized Taxis",
        "WhyChoosedescription": "Your safety is our top priority. All our cabs are regularly sanitized and well-maintained, providing a clean, secure, and comfortable ride every time you book with us."
    },
    {
        "WhyChooseheading": "Professional and Verified Drivers",
        "WhyChoosedescription": "All our drivers are background-verified, courteous, and professionally trained to offer a safe and pleasant travel experience whenever you search for 'taxi service near me'."
    },
    {
        "WhyChooseheading": "24/7 Taxi Availability Near You",
        "WhyChoosedescription": "Need a cab late at night or early in the morning? Meghana Cab operates 24/7, so there's always a reliable taxi near you whenever you need one."
    },
    {
        "WhyChooseheading": "Instant Booking via App or Website",
        "WhyChoosedescription": "Book your taxi instantly through our mobile app or website. With just a few clicks, find a nearby cab and get moving with ease and convenience."
    }
]



























    }

const faqData = [
    {
        question: "How can I find a taxi service near me through Meghana Cab?",
        answer: "Simply call us at +91 9075462128 or visit our website to book a nearby taxi with Meghana Cab. Our system finds the nearest available vehicle for you."
    },
    {
        question: "Does Meghana Cab provide instant taxi booking near my location?",
        answer: "Yes, we offer quick and reliable taxi service near your location. Based on availability, we can dispatch a cab within minutes."
    },
    {
        question: "What types of taxis are available near me?",
        answer: "We provide hatchbacks, sedans, SUVs, and tempo travellers based on your travel needs and the number of passengers."
    },
    {
        question: "Is Meghana Cab service available 24/7 near me?",
        answer: "Absolutely! Our taxi service operates 24/7 so you can book a ride anytime, anywhere in and around Pune."
    },
    {
        question: "Are the taxis from Meghana Cab safe and clean?",
        answer: "Yes, all our vehicles are regularly sanitized and maintained. Our drivers are trained and follow all safety protocols."
    },
    {
        question: "Can I book a taxi for immediate pickup near me?",
        answer: "Yes, Meghana Cab offers on-demand pickups based on proximity and availability of nearby cabs."
    },
    {
        question: "How can I pay for a nearby taxi service?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash — offering maximum flexibility."
    },
    {
        question: "Can I book a taxi near me for outstation travel?",
        answer: "Yes, you can book a taxi near your location for both local and outstation trips through Meghana Cab."
    },
    {
        question: "Do I need to register to use Meghana Cab taxi service?",
        answer: "No registration is required. Just call us or book online — it's quick and convenient."
    },
    {
        question: "How do I contact Meghana Cab for nearby taxi service?",
        answer: "To book or inquire about taxi services near you, call Meghana Cab at +91 9075462128."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Deepak Rane',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Needed a quick ride and Meghana Cab sent a taxi within 10 minutes. Great service and courteous driver!”',
    },
    {
        name: 'Ms. Aarti Jadhav',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab is my go-to when I need a taxi near me. They are fast, reliable, and always on time.”',
    },
];




















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service Near Me",
  "image": "https://www.meghanacabs.com/assets/images/taxi-service-near-me.jpg",
  "description": "Find reliable taxi service near me in Pune with Meghana Cabs. Affordable 24/7 local and outstation cab options available for quick rides, airport transfers, and daily commutes.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5330"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "300",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/taxi-service-near-me"
  }
};






    return (
        <div>

<Helmet>
  <title>Taxi Service Near Me in Pune | 24/7 Local & Outstation Cabs | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Find reliable taxi service near me in Pune with Meghana Cabs. Affordable 24/7 local and outstation cab options available for quick rides, airport transfers, and daily commutes." 
  />
  <meta 
    name="keywords" 
    content="Local Taxi Near Me Pune, Book Nearby Taxi Service Pune, Affordable Taxi Near Me Pune, 24/7 Nearby Cabs Pune, Local Cab Operator Near Me Pune, Taxi for Short Distance Near Me Pune, Outstation Cab Near Me Pune, Fast Taxi Nearby in Pune, Cab Nearby for Daily Commute Pune, Find a Cab Near Me in Pune, Airport Taxi Near Me Pune, Local Sightseeing Cab Near Me Pune, Nearby Driver Hire Pune, Emergency Taxi Near Me Pune, Taxi on Call Near Me in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/15.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Taxiservicenearme;